import React, { useState } from "react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import "./chart-3.css";
import MaleChart from "./man1";
import FemaleChart from "./man2";

import Man from "../../../../assets/Man.webp";
import Women from "../../../../assets/Women2.webp";

export default function Chart() {
  const [counterOn, setCounterOn] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      <h2 className="employees-chart-topic">
        Number returned to work after parental leave
      </h2>
      <br />

      <div className="chart-pc">
        <div className="card-container-3">
          <div className="card" style={{ width: "180px" }}>
            <div className="card-content-3">
              <ScrollTrigger
                onEnter={() => setCounterOn(true)}
                onExit={() => setCounterOn(false)}
              >
                <div className="chart-img-container-3">
                  <img src={Man} alt="" className="chart-img-3" />
                  <div className="card-overlay-3">
                    <div>
                      <h3 className="number-loader-3">
                        <div
                          style={{
                            fontSize: "12px",
                            lineHeight: "12px",
                            paddingBottom: "10px",
                          }}
                        >
                          Returned to Work
                        </div>
                        {counterOn && (
                          <CountUp
                            start={0}
                            end={1230}
                            duration={3}
                            delay={0.3}
                          />
                        )}
                      </h3>
                    </div>
                  </div>
                </div>
              </ScrollTrigger>
            </div>
          </div>

          <div className="card" style={{ width: "85px" }}>
            <div className="card-content-3">
              <MaleChart />
            </div>
          </div>

          <div className="card" style={{ width: "85px" }}>
            <div className="card-content-3">
              <FemaleChart />
            </div>
          </div>

          <div className="card" style={{ width: "180px" }}>
            <div className="card-content-3">
              <ScrollTrigger
                onEnter={() => setCounterOn(true)}
                onExit={() => setCounterOn(false)}
              >
                <div className="chart-img-container-3">
                  <img src={Women} alt="" className="chart-img-3" />
                  <div className="card-overlay-3">
                    <div>
                      <h3 className="number-loader-3">
                        <div
                          style={{
                            fontSize: "12px",
                            lineHeight: "12px",
                            paddingBottom: "10px",
                          }}
                        >
                          Did not return to work
                        </div>
                        {counterOn && (
                          <CountUp
                            start={0}
                            end={379}
                            duration={3}
                            delay={0.3}
                          />
                        )}
                      </h3>
                    </div>
                  </div>
                </div>
              </ScrollTrigger>
            </div>
          </div>
        </div>
      </div>

      {/* //// */}
      <div className="chart-mobile">
        <div className="card-container-3">
          <div className="card" style={{ width: "130px" }}>
            <div className="card-content-3">
              <ScrollTrigger
                onEnter={() => setCounterOn(true)}
                onExit={() => setCounterOn(false)}
              >
                <div className="chart-img-container-3">
                  <img src={Man} alt="" className="chart-img-3" />
                  <div className="card-overlay-3">
                    <div>
                      <h3 className="number-loader-3">
                        {counterOn && (
                          <CountUp
                            start={0}
                            end={36}
                            duration={3}
                            delay={0.3}
                          />
                        )}
                        %
                      </h3>
                    </div>
                  </div>
                </div>
              </ScrollTrigger>
            </div>
          </div>

          <div className="card" style={{ width: "100px" }}>
            <div className="card-content-3">
              <MaleChart />
            </div>
          </div>
        </div>
        <div>
          <div className="card-container-3">
            <div className="card" style={{ width: "100px" }}>
              <div className="card-content-3">
                <FemaleChart />
              </div>
            </div>

            <div className="card" style={{ width: "130px" }}>
              <div className="card-content-3">
                <ScrollTrigger
                  onEnter={() => setCounterOn(true)}
                  onExit={() => setCounterOn(false)}
                >
                  <div className="chart-img-container-3">
                    <img src={Women} alt="" className="chart-img-3" />
                    <div className="card-overlay-3">
                      <div>
                        <h3 className="number-loader-3">
                          {counterOn && (
                            <CountUp
                              start={0}
                              end={64}
                              duration={3}
                              delay={0.3}
                            />
                          )}
                          %
                        </h3>
                      </div>
                    </div>
                  </div>
                </ScrollTrigger>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /// */}
    </div>
  );
}
